import { useEffect } from 'react'
import AmDashboard from "./AccountManager/AmDashboard"
import DealerDashboard from "./Dealer/DealerDashboard"
import Login from "./Login"
import useStore from "../store"
import useUserType from '../hooks/useUserType'

export default function Dashboard() {
  const { isLoggedIn, isEmployee, isDealer } = useUserType()
  const setNavBarHidden = useStore((state) => state.setNavBarHidden)
  const setTopNavHidden = useStore((state) => state.setTopNavHidden)

  useEffect(() => {
    setNavBarHidden(false)
    setTopNavHidden(false)
  })

  if (isLoggedIn) {
    if (isEmployee) {
      return <AmDashboard />
    } else if (isDealer) {
      return <DealerDashboard/>
    }
  }

  return <Login />
}
